import classNames from "classnames";
import React, { PureComponent } from "react";

import { flexDirectionClass, innerBorderClass, IStyleFlexDirection, IStyleInnerBorder } from "../Style";

interface Props extends Partial<IStyleFlexDirection & IStyleInnerBorder> {
  activeIndex?: number;
  className?: string;
}

export interface IWithTabContextProps {
  activeIndex?: number;
  onActivate?: (activeIndex: number) => void;
}

export const TabsContext = React.createContext<IWithTabContextProps>({});

export const withTabsContext = <P extends IWithTabContextProps>(Component: React.ComponentType<P>) => {
  type TabsContextProps = Omit<P, keyof IWithTabContextProps>;

  const WithTabContext: React.FC<TabsContextProps> = props => {
    return <TabsContext.Consumer>{value => <Component {...value} {...(props as any)} />}</TabsContext.Consumer>;
  };
  return WithTabContext;
};

type State = IWithTabContextProps;
export class Tabs extends PureComponent<Props, State> {
  static defaultProps: Partial<Props> = {
    direction: "column",
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      activeIndex: this.props.activeIndex || 0,
      onActivate: this.handleActivate,
    };
  }

  handleActivate = (activeIndex: number) => {
    this.setState({ activeIndex });
  };

  render() {
    const { className, children, direction, innerBorder } = this.props;

    const classes = classNames("el-tabs", flexDirectionClass(direction), innerBorderClass(innerBorder), className);

    return (
      <TabsContext.Provider value={this.state}>
        <div className={classes}>{children}</div>
      </TabsContext.Provider>
    );
  }
}
